module.exports = __webpack_public_path__ + "static/offer-wireframe-1-10643d9d4f1e18089fcc738e087f9f4e.jpg";